<template>
  <aside class="west-slide-left-navigation">
    <nuttrema-menu-list>
      <nuttrema-menu-list-item theme="brand-image">
        <span>
          <img src="~assets/images/dc-logo-small-white.svg" alt="Diet Creator :: Logo">
        </span>
      </nuttrema-menu-list-item>
      <nuttrema-menu-list-item :style-props="{ 'justify-content': 'center' }">
        <slot></slot>
      </nuttrema-menu-list-item>
    </nuttrema-menu-list>
  </aside>
</template>

<script>
import NuttremaMenuList from 'components/ui/navigation/nuttrema-menu-list';
import NuttremaMenuListItem from 'components/ui/navigation/nuttrema-menu-list-item';

export default {
  name: 'west-slide-left-navigation',
  components: {
    NuttremaMenuList,
    NuttremaMenuListItem,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/west-slide-component/west-slide-left-navigation.vue